'use client';

import { navigationConfig } from '@/components/navigation/navigation.config';
import { useLocalePath } from '@/shared/hooks';
import { useT } from 'next-i18next/client';
import { useRouter } from 'next/navigation';
import { useState, type FC } from 'react';

export const MobileNavigation: FC = () => {
  const [open, setOpen] = useState(false);
  const { t } = useT(navigationConfig.i18nNamespaces);
  const { to } = useLocalePath();
  const router = useRouter();

  const links = [
    { href: to('/projects'), label: t('navigation:topNav.projects') },
    { href: to('/services'), label: t('navigation:topNav.services') },
    { href: to('/process'), label: t('navigation:topNav.process') },
    { href: to('/about'), label: t('navigation:topNav.about') },
    { href: to('/contact'), label: t('navigation:topNav.startAProject') },
  ];

  const handleNav = (href: string) => {
    setOpen(false);
    router.push(href);
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex items-center justify-center text-white"
        aria-label="Open menu"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
          <line x1="3" y1="8" x2="21" y2="8" />
          <line x1="3" y1="16" x2="21" y2="16" />
        </svg>
      </button>

      {open && (
        <div className="fixed inset-0 z-[100] bg-[#0A0A0A] flex flex-col px-6 py-6">
          <div className="flex justify-end">
            <button
              onClick={() => setOpen(false)}
              className="text-white/60 hover:text-white transition-colors"
              aria-label="Close menu"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
          <nav className="flex flex-col gap-8 mt-16">
            {links.map(({ href, label }) => (
              <button
                key={href}
                onClick={() => handleNav(href)}
                className="text-left text-[40px] font-medium text-white/60 hover:text-white transition-colors duration-150 leading-none"
              >
                {label}
              </button>
            ))}
          </nav>
        </div>
      )}
    </>
  );
};
